/**
 * File animations.js
 *
 * Handles global animations
 */

(() => {
    // Page fade in on load
    // document.body.classList.add( 'fade-in' );

    // (() => {
    //     document.body.classList.remove( 'fade-in' );
    // });

    // Block scroll to next block
    const blockScroll = document.querySelector( '.block-link-scroll' );
    const blockLinkScroll = document.querySelector( '.block-link-scroll .image-link.scroll-to-next' );

    if ( blockLinkScroll ) {
        blockLinkScroll.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            window.scroll( { left: 0, top: blockScroll.nextElementSibling.offsetTop } );
        });
    }

    // Collapse - add rotated class
    document.querySelectorAll( '.collapse-indicator-plus > img' ).forEach(function ( e ) {
        e.parentNode.addEventListener( 'click', function () {
            e.classList.toggle( 'rotated' );
        });
    });
})();